import { render, staticRenderFns } from "./Evaluation.vue?vue&type=template&id=356b5796"
import script from "./Evaluation.vue?vue&type=script&lang=js"
export * from "./Evaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports